export default "__VITE_ASSET__B8rSD_F2__"